import { useEffect } from "react";

/**
 * Adds <meta name="robots" content="noindex, nofollow"> while the component is mounted.
 * Use on private surfaces (admin, judge) so search engines never index them.
 */
export default function useNoindex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, []);
}
